import Commons from "oc-commons/Commons.js";

/**
 * Erlaubt es, Änderungen in den Settings lokal im Browser zu speichern
 * @param localStorageKey der App-Name
 * @param defaultSettings die normalen Settings der App
 * @returns {{get: get, getMerge: getMerge, remove: remove, set: set, setMerge: setMerge, checkbox: checkbox}}
 * @example
 * const settingsHandler = localSettings('zaunplanerAppSettings',settings);
 * const app = new Zaunplaner($('#Configurator'),
 *                            settingsHandler.getMerge());
 */
export default function localSettings(localStorageKey, defaultSettings) {
    const get = () => JSON.parse(localStorage[localStorageKey] || "{}");
    const getMerge = () => defaultSettings ? Commons.defaultsDeepSafe({}, get(), defaultSettings) : get();
    const remove = () => delete localStorage[localStorageKey];
    const set = (config) => localStorage[localStorageKey] = config == null ? null : JSON.stringify(config);
    const setMerge = (config) => set(Commons.defaultsDeepSafe({}, config, get()));
    return {
        get,
        getMerge,
        remove,
        set,
        setMerge,
    };
}
